/**---------------------------------------------
 * data-animation="underlline"
**-----------------------------------------------*/
export const AnimationUnderline = () => {
  console.log('AnimationUnderline');

  const targets = document.querySelectorAll('[data-animation="underline"]');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // 親の親要素を取得
      const grandparent = entry.target.parentElement?.parentElement;
      const innerTargets = grandparent ? grandparent.querySelectorAll('[data-animation="underline"]') : [];

      if (entry.isIntersecting) {
        // 要素が画面に入った場合、順番にアニメーションを適用
        if (innerTargets.length > 0) {
          applyUnderlineSequentially(Array.from(innerTargets));
        }
      } else {
        // 要素が画面から外れた場合、アンダーラインを即座に消去
        innerTargets.forEach(element => {
          element.style.transition = "none"; // トランジションを一時的に無効化
          element.classList.remove("underline-active");
          // リフローを発生させてtransitionをリセット
          void element.offsetWidth;
          element.style.transition = ""; // 元のトランジションに戻す
        });
      }
    });
  });

  targets.forEach(target => observer.observe(target));
};

// 各要素に順番にアンダーラインを適用するPromise関数
const applyUnderlineSequentially = (elements) => {
  return elements.reduce((promise, element) => {
    return promise.then(() => {
      return new Promise((resolve) => {
        setTimeout(() => {
          element.classList.add("underline-active");
          resolve();
        }, 1000); // 1秒の遅延
      });
    });
  }, Promise.resolve());
};
